import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { IsDefaultKeyValue } from "source/app/infrastructure/Data/KeyValues/defaultKeyValue";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { broadStateSelectorData } from "source/app/presentation/Shared/ActivePanel/BroadStateSelectors/IBroadStateSelector/broadStateSelectorData";

export function GetAveragePercent() {
    const broadStateSelectorSharedFunctions = broadStateSelectorData.map(
        (bss) => bss.sharedFunction
    );

    const keyValuesSum = broadStateSelectorSharedFunctions
        .map((esf) => {
            const keyValue = ReadState<IKeyValue>(esf);

            if (!keyValue || IsDefaultKeyValue(keyValue)) {
                return -1;
            }

            const value = Number.parseFloat(keyValue.value);
            return value;
        })
        .reduce((a, b) => a + b);

    // Handle keyvalues not being available yet
    if (keyValuesSum < 0) {
        return undefined;
    }

    const average = keyValuesSum / broadStateSelectorSharedFunctions.length;
    const averagePercent = Math.floor((average / 5.0) * 100);
    return averagePercent;
}
